import { Link } from "react-router-dom";
import { Clock, ArrowRight, MapPin, Phone, MessageCircle } from "lucide-react";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets`;

export default function Hero() {
  return (
    <section className="relative pt-10 md:pt-16 pb-12 md:pb-24 overflow-hidden" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          {/* Left text column */}
          <div className="lg:col-span-7 relative z-10">
            <div className="inline-flex items-center gap-2 sticker bg-mint text-choc mb-6" data-testid="hero-since-badge">
              <Clock className="w-3.5 h-3.5"/> Open 24 hours · Since 1999
            </div>
            <h1 className="font-display text-[clamp(2.5rem,7vw,5.5rem)] leading-[0.95] tracking-tight">
              Celebrate <span className="text-holiday-red">Big</span><br/>
              with <span className="relative inline-block">
                Holiday
                <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden>
                  <path d="M2 8 Q 50 2, 100 7 T 198 6" stroke="#FFD166" strokeWidth="6" fill="none" strokeLinecap="round"/>
                </svg>
              </span>
              <br/><span className="font-serif italic font-medium text-choc/80">Ice Creams.</span>
            </h1>
            <p className="mt-6 text-base md:text-lg max-w-xl text-choc/80 leading-relaxed">
              26 years of slow-cooked kulfi, hand-folded family tubs and party-sized bulk packs — made in Gorakhpur, served around the clock.
            </p>

            <div className="mt-8 flex flex-wrap gap-3" data-testid="hero-cta-row">
              <Link to="/products" className="inline-flex items-center gap-2 bg-holiday-red text-white px-7 py-3.5 rounded-full font-bold hover:bg-holiday-red-deep transition-all hover:scale-105" data-testid="hero-cta-explore-menu">
                Explore Menu <ArrowRight className="w-4 h-4"/>
              </Link>
              <Link to="/bulk-order" className="inline-flex items-center gap-2 bg-choc text-cream px-7 py-3.5 rounded-full font-bold hover:bg-choc/90 transition-all" data-testid="hero-cta-bulk-orders">
                Bulk Orders
              </Link>
              <a href="https://maps.app.goo.gl/xd1he1c7UpNeaTuV9" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-white border-2 border-choc px-7 py-3.5 rounded-full font-bold hover:bg-mint transition-colors" data-testid="hero-cta-find-us">
                <MapPin className="w-4 h-4"/> Find Us
              </a>
              <Link to="/contact" className="inline-flex items-center gap-2 bg-white border-2 border-choc px-7 py-3.5 rounded-full font-bold hover:bg-ice-pink transition-colors" data-testid="hero-cta-contact">
                <MessageCircle className="w-4 h-4"/> Contact
              </Link>
            </div>

            <div className="mt-10 flex items-center gap-6 text-sm">
              <div>
                <div className="font-display text-3xl text-holiday-red">4.9★</div>
                <div className="text-xs uppercase tracking-widest text-choc/60">31 Google Reviews</div>
              </div>
              <div className="w-px h-10 bg-choc/15"/>
              <div>
                <div className="font-display text-3xl">26 yrs</div>
                <div className="text-xs uppercase tracking-widest text-choc/60">Of love · Since '99</div>
              </div>
              <div className="w-px h-10 bg-choc/15"/>
              <a href="tel:9235372759" className="flex items-center gap-2 hover:text-holiday-red" data-testid="hero-call-link">
                <Phone className="w-4 h-4"/> <span className="font-bold">9235372759</span>
              </a>
            </div>
          </div>

          {/* Right visual column */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] rounded-[2.5rem] overflow-hidden cushion border border-[#F0E4E4] bg-ice-pink">
              <img
                src={`${ASSET_BASE}/menu/kulfi-pista.jpg`} alt=""
                className="absolute inset-0 w-full h-full object-cover"
                aria-hidden
              />
              <video
                src={`${ASSET_BASE}/videos/scoop.mp4`}
                autoPlay loop muted playsInline preload="auto"
                poster={`${ASSET_BASE}/menu/kulfi-pista.jpg`}
                className="relative w-full h-full object-cover"
                data-testid="hero-video"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-choc/30 to-transparent"/>
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                <span className="sticker bg-cream text-choc">★ Made fresh today</span>
                <span className="sticker bg-holiday-red text-white animate-wobble">Holiday Like No Other</span>
              </div>
            </div>

            {/* Floating stickers */}
            <div className="hidden md:block absolute -top-4 -left-6 bg-sun-yellow text-choc rounded-full px-4 py-2 font-bold text-sm shadow-lg rotate-[-8deg] animate-float-slow">
              ₹100–₹170 family packs
            </div>
            <div className="hidden md:block absolute -bottom-4 -right-3 bg-mint-deep text-choc rounded-full px-4 py-2 font-bold text-sm shadow-lg rotate-[6deg] animate-float-slow" style={{ animationDelay: "1.5s" }}>
              Bulk discounts ₹425+
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

